import React, { Component } from "react";
import Navbar from "../../../components/Navbar";
import Header from "../../../components/Header";
import EmailVerificationBanner from "../../../components/EmailVerificationBanner";
import CookiesBar from "../../../components/CookiesBar";
import PropTypes from "prop-types";

class MainLayout extends Component {
  render() {
    const {
      authorized,
      isEmailVerificationBannerVisible,
      isEmailVerificationBannerDismissed,
      user,
      isCookiesBarVisible,
    } = this.props;
    const shouldShowEmailVerificationBanner =
      authorized && isEmailVerificationBannerVisible && !isEmailVerificationBannerDismissed;
    return (
      <div className="main">
        <Header>
          <p>CaseMasters</p>
        </Header>
        {shouldShowEmailVerificationBanner && <EmailVerificationBanner user={user} />}
        {isCookiesBarVisible && <CookiesBar />}
        <div className="main__container">{this.props.children}</div>
        {this.props.noNavbar ? null : <div>{authorized && <Navbar />}</div>}
      </div>
    );
  }
}

MainLayout.propTypes = {
  authorized: PropTypes.bool.isRequired,
  user: PropTypes.object,
  isEmailVerificationBannerVisible: PropTypes.bool.isRequired,
};

export default MainLayout;



// WEBPACK FOOTER //
// ./src/util/Layouts/MainLayout/index.js